export interface IVariablesReservation {
    reservaCodigo: string;
    reservaDataEntrada: string;
    reservaDataSaida: string;
    reservaHorarioEntrada: string;
    reservaHorarioSaida: string;
    reservaStatus: string;
    reservaStatusPagamento: string;
    reservaStatusCheckin: string;
    reservaOrigem: string;
    reservaDataCriacao: string;
    checkinDataCriacao: string;
    checkinSenhaAcomodacao: string;
    checkinSenhaAreaAcesso: string;
    acomodacaoCodigo: string;
    acomodacaoNome: string;
    acomodacaoLocalizacao: string;
    acomodacaoTipoAcesso: string;
    acomodacaoMaisInfo: string;
    acomodacaoRedeWifi: string;
    acomodacaoSenhaWifi: string;
    acomodacaoFechadura: string | null;
    acomodacaoAreasAcesso: string;
    guests: {
        name: string;
        email: string;
        phone: string;
        birth: string;
        cpf: string;
        rg: string | null;
        type: string;
        primary: boolean;
    }[];
    hoje: string;
    diaAtual: number;
    diaAtualExtenso: string;
    mesAtual: string;
    mesAtualExtenso: string;
    anoAtual: number;
    anoAtualExtenso: string;
    checkinLink: string;
    checkoutLink: string;
    checkinLinkPDF: string;
    empresaRazaoSocial: string;
    empresaNomeFantasia: string;
    empresaCNPJ: string;
    empresaEmail: string;
    empresaTelefone: string;
    empresaEndereco: string;
    acomodacaoURLCapa: string;
}

export const replaceVariables = (variables: IVariablesReservation, text: string) => {
    let newText = text;
    const regex = /\{\{([^}]+)\}\}/g;
    let match;
    while ((match = regex.exec(text)) !== null) {
        const variableName = match[1];
        const variableValue = variables[variableName as keyof IVariablesReservation];
        if (variableValue !== undefined) {
            newText = newText.replace(match[0], variableValue as string);
        }
    }
    return newText;
}